<template>

    <div id="document-invitations">
        <document-set-header v-bind:document-set="store.data.currentDocumentSet"></document-set-header>
        <h1>Account Access</h1>
        <div class="row">
            <div class="invitations-block col-xs-12">
                <div class="row header clearfix">
                    <div class="col-xs-7">
                        <strong>Name</strong>
                    </div>
                    <div class="col-xs-3">
                        <strong>Status</strong>
                    </div>
                    <div class="col-xs-2 action">
                    </div>
                </div>
                <div class="row" v-for="invitation in invitations">
                    <div class="col-xs-7">
                        {{ invitation.user.firstName }} {{ invitation.user.lastName }}
                    </div>
                    <div class="col-xs-3">
                        {{ invitation.shareStatus }}
                    </div>
                    <div class="col-xs-2 action">
                        <button class="btn btn-xs btn-danger" @click="revoke(invitation)"><i class="fa fa-ban"></i></button>
                    </div>
                </div>
            </div>
            <div class="recipients-block col-xs-12">
                <!-- <h3>Send {{toShare.length}} document<span v-if="toShare.length!=1">s</span> to:</h3> -->
                <h3>Invite:</h3>
                <div v-for="recipient in recipients">
                    <div class="form-group row">
                        <div class="recipient col-xs-12">
                            <div class="fields">
                                <input type="text" v-model="recipient.userFirstName" class="form-control" placeholder="first name">
                                <input type="text" v-model="recipient.userLastName" class="form-control" placeholder="last name">
                                <input type="email" v-model="recipient.userEmail" class="form-control" placeholder="email">
                            </div>
                            <button class="btn btn-danger btn-xs action removeRecipient" @click="removeRecipient(recipient)"><i class="fa fa-ban"></i></button>
                        </div>

                    </div>
                </div>
                <div class="form-group">
                    <button class="btn btn-md btn-primary" @click="addRecipient"><i class="fa fa-plus-circle"></i> Add recipient</button>
                    <button v-if="recipients.length" class="btn btn-md btn-success" @click="invite"><i class="fa fa-send"></i> Send</button>
                    <router-link :to="{ name: 'DocumentsView' }" class="btn btn-warning">Done</router-link>
                </div>
            </div>
        </div>
    </div>

</template>



<script>

    import DocumentSetHeader from '@/components/DocumentSetHeader'
    import DocumentSetsService from '@/services/document-sets.service'
    import { Store } from '@/store.js'
    import UserInvitationsService from '@/services/user-invitations.service'
    
    export default {
        
        name: 'documentsShare',
        
        data() {
            return {
                store: Store,
                invitations: [],
                invitationToAdd: {},
                recipients: []
            }
        },
        
        created: function() {
            this.requestDocumentSet(this.setId, this.setType)
            this.requestDocumentSetInvitations(this.setId)
            this.resetForm()
            this.addRecipient()
        },
        
        computed: {
            setId: function() { return this.$route.params.setId; },
            setType: function() { return this.$route.params.setType; }
        },
        
        components: {
            'document-set-header' : DocumentSetHeader
        },

        methods: {

            requestDocumentSet: function(setId, setType) {
                DocumentSetsService.getSet(setId, setType)
                    .then(use.bind(this))

                function use(set) {
                    this.store.data.currentDocumentSet = set
                    return set;
                }

            },

            requestDocumentSetInvitations: function(setId) {
                return UserInvitationsService.getInvitationsForDocumentSet(setId)
                    .then(use.bind(this))

                function use(invitations) {
                    this.invitations = invitations
                    return invitations
                }

            },

            revoke: function(invitation) {
                if (!confirm('Revoke ' + invitation.user.firstName + ' ' + invitation.user.lastName + '\'s access to ' + this.store.data.currentDocumentSet.name + '?')) return;
                var component = this
                return UserInvitationsService.revokeAccessForDocumentSet(this.setId, invitation)
                    .then(reload.bind(component))

                function reload(result) {
                    return this.requestDocumentSetInvitations(this.setId)
                }

            },

            invite: function() {
                var component = this
                UserInvitationsService.postInvitationsForDocumentSet(this.setId, this.recipients)
                    .then(reload.bind(component))
                    .then(clearForm.bind(this))

                function reload(result) {
                    return this.requestDocumentSetInvitations(this.setId)
                }

                function clearForm(result) {
                    this.resetForm()
                    return result
                }

            },

            addRecipient: function() {
                this.recipients.push({
                    userFirstName: '',
                    userLastName: '',
                    userEmail: ''
                })
            },

            removeRecipient: function(val) {
                this.recipients = this.recipients.filter(function(el) {
                    return el !== val
                })
            },

            resetForm: function() {
                this.recipients = [];
            }
        }
    }
</script>



<style lang="scss" scoped>

    .submit-container {
        text-align: right;
    }

    .recipient {
        position: relative;

        .fields {
            width: calc(100% - 3em);

            .form-control {
                margin: 5px 0;
            }
        }

        @media (min-width:760px) {
            .fields {
                display: flex;

                .form-control {
                    margin: 0 5px;
                }
            }
        }

        button {
            position: absolute;
            top: 5px;
            right: 25px;
        }
    }

    .invitations-block {
        text-align: left;
    }
    .action {
        text-align: right;
    }

</style>



// WEBPACK FOOTER //
// DocumentsInvitations.vue?4d4ed96c